import api from 'config/axios';
import AppService from 'common/app-service';
import { IUserRegistry } from 'common/user.interface';
import { IPerson } from 'common/person-register.interface';

export default class AccountService extends AppService {
  constructor() {
    super('accounts', api);
  }

  async getMe(): Promise<IUserRegistry> {
    const response = await this.api.get(`${this.servicePath}/me`);

    return response.data;
  }

  async registerCustomer(params: Partial<IUserRegistry>): Promise<IPerson> {
    const response = await this.api.post(this.root('register/customer'), params);
    return response.data;
  }

  async verifyToken(params: { token: string }): Promise<{ isValid: boolean }> {
    const response = await this.api.post(this.root('register/verify-token'), params, { params: { isPublicRequest: true } });

    return response.data;
  }

  async verifyEmail(params: { email: string }): Promise<{ isValid: boolean }> {
    const response = await this.api.post(this.root('register/verify-email'), params);

    return response.data;
  }

  async completeRegistration(params: { password: string; token: string }): Promise<void> {
    const response = await this.api.post(this.root('register/complete'), params, { params: { isPublicRequest: true } });

    return response.data;
  }

  async sendCompleteRegisterEmail(params: { personId: number }): Promise<void> {
    const response = await this.api.post(this.root('register/complete-email'), params);

    return response.data;
  }
}
